import { createApp, ref, provide, reactive } from 'vue';
import App from './App.vue';
import FloatingVue from 'floating-vue';
import router from './router';

import './styles/core.scss';
import 'floating-vue/dist/style.css';
import 'floating-vue/dist/style.css';
import '@vueform/multiselect/themes/default.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

// required for webpack file loader
require('../favicon.ico');

const app = createApp(App);

// Tooltip settings
FloatingVue.options.themes.tooltip.delay.show = 0;
FloatingVue.options.themes.tooltip.triggers = ['hover', 'click'];

app.use(router);
app.use(FloatingVue);
app.mount('#app');
